import React, { useState, useMemo } from 'react'
import { DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import StyledDialog from '../../Common/Dialogs/StyledDialog'
import { MainButton } from '../../Button/MainButton'
import useSelectedFacility from '../../../hooks/useSelectedFacility'
import StyledAlert from '../../Common/StyledAlert'
import CheckboxMenu from '../../Common/Menus/CheckboxMenu'
import PetAvatar from '../../Common/PetAvatar'
import StyledTextField from '../../Common/StyledTextField'
import PetAutocomplete from '../../Autocompletes/Pet'


const useStyles = makeStyles(() => ({
	dialogContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '0 1.5rem',
		gap: '1rem',
		flex: 1
	},
	rowWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem'
	},
	dialogActions: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		gap: '1rem',
		margin: '2rem 0 1rem 0',
		'& .MuiButton-outlinedSizeLarge': {
			height: 'unset'
		},
		justifySelf: 'flex-end'
	},
	petAvatarContainer: {
		display: 'flex',
		gap: '1rem',
		alignItems: 'center'
	}
}))

/**
 *
 * @param {{
  open: Boolean, 
	onClose: Function, 
	onCancelled: Function,
	title: String,
	trainingClass: Object,
	session: Object
}} params
 * @returns
 */
const SearchClientDialog = ({
	open,
	onSaved,
	onCancelled,
	title = 'Add Pet',
	pet = {},
	trainingClass,
	session,
	addBeefs
}) => {
	const classes = useStyles()

	const [editedEnrollment, setEditedEnrollment] = useState({})
	const [error, setError] = useState(null)
	const [loading, setLoading] = useState(false)
	const [selectedPets, selectPets] = useState([])

	const handleResetDialog = () => {
		setEditedEnrollment({})
		setError(null)
		selectPets([])
	}

	const handleOnCancelled = () => {
		if (onCancelled) {
			handleResetDialog()
			onCancelled()
		}
	}


    const togglePet = (petId) => {
        if (selectedPets.includes(petId)) {
            selectPets(selectedPets.filter(pet => pet !== petId))
        } else {
            selectPets([...selectedPets, petId])
        }
    }

	const moreBeefs = () => {
		addBeefs(selectedPets)
		handleOnCancelled()
	}

	return (
		<>
			<StyledDialog
				open={open}
				onClose={handleOnCancelled}
				title={title}
				showActivityIndicator={loading}
				minHeight={500}
				minWidth={500}
				maxWidth={500}>
				<DialogContent style={{ display: 'flex' }}>
					<div className={classes.dialogContent}>
						<div className={classes.rowWrapper}>
							
							<PetAutocomplete
								displayAddress={false}
								onHouseholdSelected={(household) => console.log('household', household)}
								togglePet={togglePet}
								selectedPets={selectedPets}
								pet={pet}
								additionalSearchParams={{
									includePets: true,
									includeVaccines: true,
									includeAccounts: true,
									includeTraining: false
								}}
							/>
							
							{error ? <StyledAlert type="error" text={error} /> : null}
						</div>
						<div className={classes.dialogActions}>
							<MainButton
								label="Confirm"
								onClick={moreBeefs}
								variant="contained"
							/>
							<MainButton label="Cancel" onClick={handleOnCancelled} />
						</div>
					</div>
				</DialogContent>
			</StyledDialog>
		</>
	)
}

export default SearchClientDialog
